import {useMutation} from "@tanstack/react-query";

import {addSupplierNoteMutationOptions} from "./add-supplier-note.mutation-options";

export function useAddSupplierNote(supplierId: string) {
  return useMutation(addSupplierNoteMutationOptions(supplierId));
}
